import { useEffect } from 'react';

export default function Toast({ message, visible, onHide, type = 'error', duration = 4000 }) {
  useEffect(() => {
    if (!visible || !duration) return;
    const t = setTimeout(onHide, duration);
    return () => clearTimeout(t);
  }, [visible, duration, onHide]);

  const iconConfig = {
    success: {
      bg: '#22c55e',
      icon: <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>,
    },
    error: {
      bg: '#ef4444',
      icon: <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>,
    },
    info: {
      bg: '#3b82f6',
      icon: <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M12 8h.01M12 12v4" /></svg>,
    },
  };
  const { bg, icon } = iconConfig[type] ?? iconConfig.error;

  return (
    <div className={`elig-toast${visible ? ' elig-toast--visible' : ''}`}>
      <div className="elig-toast-icon" style={{ background: bg }}>
        {icon}
      </div>
      <span className="elig-toast-msg">{message}</span>
      <button className="elig-toast-close" onClick={onHide} aria-label="Dismiss">
        <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
